export const prizeRewards = (prize) => {
  const { money, attempts, gacha_event_cash, gachaItem, type } = prize;
  const isPromo = ['BonusScore', 'Promocode'].includes(type);

  return [
    { type: isPromo && 'promo', value: 'none' },
    { type: 'coin', value: money },
    { type: 'energy', value: attempts },
    { type: 'charm', value: gacha_event_cash },
    { type: 'gachaItem', value: gachaItem && 'none' },
    { type: 'Hidden', value: !isPromo && !money && !attempts && !gacha_event_cash && !gachaItem && 'none' },
  ].filter(({ type, value } = {}) => type && value);
};
